import OrganicSearchApi from '@/api/organic-search/organic-search-api';
import OrganicCompetitorsApi from './organic-competitors-api';
import {getApiUrl} from '@/api/common-utils';
import {BaseApi} from '../base-api';

export const ORGANIC_SEARCH_API = new OrganicSearchApi(getApiUrl(BaseApi.GSC_ENDPOINT, '/api'));
export const ORGANIC_COMPETITORS_API = new OrganicCompetitorsApi(getApiUrl(BaseApi.KEYWORD_ENDPOINT, '/api'));
